// extracted by mini-css-extract-plugin
export var avatar = "_he-3";
export var avatarContainer = "_he-2";
export var avatarSpacer = "_he-5";
export var avatarSpacerContainer = "_he-4";
export var avatarStackContainer = "_he-1";
export var bubble = "_he-0";
export var remainderBubble = "_he-6";